import { useRecoilValueLoadable } from 'recoil'
import { MFSIPs } from '../../store/AdminStore'
import MFOrdersSkeleton from '../../Components/SkeletonLoaders/MFOrdersSkeleton'
import { Card, CardContent, CardHeader, CardTitle } from '../../Components/ui/card'
import env from '../../env/env'
import SIPTable from './SIPTable'

const UserSIPs = ({ clientCode }) => {
  const userSIPs = useRecoilValueLoadable(MFSIPs(clientCode))
  const parseSIPs = userSIPs?.state === 'hasValue' && JSON.parse(userSIPs?.contents?.data)
  const sips = parseSIPs?.data || []

  if (sips.length === 0) {
    return (
      <div className='bg-white flex items-center justify-center'>
        <Card className='w-full max-w-2xl text-center border-none shadow-none font-DMSans'>
          <CardHeader className='flex flex-col gap-y-6 justify-center items-center'>
            <img
              className='h-14 w-14 mx-auto'
              src={`${env.SVGS}/error-icon.svg`}
              alt='Error-Icon'
            />
            <CardTitle className='font-semibold text-base'>SIP Not Found or Fetch Error</CardTitle>
          </CardHeader>
          <CardContent className='flex flex-col gap-y-6'>
            <p className='text-sm leading-5 text-black-400 mb-6'>
              We're sorry, but it seems there was an issue fetching your SIPs. Either there are no
              active SIPs linked to your account, or we're experiencing a temporary server issue.
              Please try refreshing the page or check again later.
            </p>

            {/* <div className='flex gap-x-2 justify-between'>
              <Button
                className='w-full'
                variant='fabitsWhite'
                onClick={() => window.location.reload()}
              >
                <Refresh className='mr-2 h-4 w-4 text-black-300' /> Refresh
              </Button>

              <Link className='flex-1' to='/dashboard/mutual-funds'>
                <Button className='w-full'>
                  View Plans
                  <MoveRight className='ml-2 h-4 w-4' />
                </Button>
              </Link>
            </div> */}
          </CardContent>
        </Card>
      </div>
    )
  }

  switch (userSIPs.state) {
    case 'loading':
      return (
        <div className='max-w-[1128px] mx-auto'>
          <MFOrdersSkeleton />
        </div>
      )

    case 'hasValue':
      return (
        <div className='bg-white min-h-screen'>
          <SIPTable sips={sips} clientCode={clientCode} />
        </div>
      )

    case 'hasError':
      return (
        <div className='bg-white flex items-center justify-center'>
          <Card className='w-full max-w-2xl text-center border-none shadow-none font-DMSans'>
            <CardHeader className='flex flex-col gap-y-6 justify-center items-center'>
              <img className='h-14 w-14' src={`${env.SVGS}/error-icon.svg`} alt='Error-Icon' />
              <CardTitle className='font-semibold text-base'>
                {/* SIP Not Found or Fetch Error */}
              </CardTitle>
            </CardHeader>
            <CardContent className='flex flex-col gap-y-6'>
              <p className='text-sm leading-5 text-black-400 mb-6'>
                We're sorry, but it seems there was an issue fetching your SIPs. Either there are no
                active SIPs linked to your account, or we're experiencing a temporary server issue.
                Please try refreshing the page or check again later.
              </p>
            </CardContent>
          </Card>
        </div>
      )

    default:
      return null
  }
}

export default UserSIPs
